import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LINKS, SERVICES } from "@/data/content";
import { fadeUp, staggered } from "@/lib/motion";

const ServiceCard = ({ service, index }) => (
  <motion.article
    id={service.id}
    data-testid={`service-card-${service.id}`}
    {...staggered(fadeUp, index, 0.15)}
    className="group scroll-mt-28 flex flex-col border border-navy/10 bg-white p-7 lg:grid lg:grid-rows-subgrid lg:row-span-6"
  >
    <div className="flex items-start gap-3">
      <p className="font-heading text-xl font-bold leading-[1.15] text-navy sm:text-2xl">0{index + 1}.</p>
      <h3 className="font-heading text-xl font-bold leading-[1.15] tracking-tight text-ink sm:text-2xl">{service.title}</h3>
    </div>
    <p className="mt-3 text-sm text-ink/65">{service.intro}</p>
    {service.points.map((p, i) => (
      <div key={p.title} data-testid={`service-point-${service.id}-${i + 1}`} className={`pt-6 ${i === 0 ? "mt-6" : "mt-6 border-t border-navy/10"}`}>
        <p className="font-heading text-lg font-semibold text-navy sm:text-xl">{p.title}</p>
        <p className="mt-2 text-sm leading-relaxed text-ink/65">{p.body}</p>
      </div>
    ))}
    <Button asChild variant="ghost" data-testid={`service-cta-${service.id}`} className="btn-ghost mt-8 self-start px-0 hover:bg-transparent">
      <a href={LINKS.calendly} target="_blank" rel="noopener noreferrer">
        Work with PKR <ArrowUpRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </a>
    </Button>
  </motion.article>
);

export const Services = () => (
  <section id="services" data-testid="services-section" className="scroll-mt-24 bg-navy py-14 sm:py-20 text-white">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <div className="max-w-2xl">
        <h2 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">How can we help?</h2>
        <p className="mt-5 text-base leading-relaxed text-white/75 sm:text-lg">
          Three ways to work together, all built around your hiring reality, not a one-size-fits-all model.
        </p>
      </div>
      <div className="mt-12 grid gap-6 lg:grid-cols-3 lg:grid-rows-[auto_auto_auto_auto_auto_auto]">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.id} service={s} index={i} />
        ))}
      </div>
    </div>
  </section>
);
